import React, { useState, useEffect } from 'react';
import { Sun, Shield, Droplets, Thermometer, Check, Phone, Mail, Star } from 'lucide-react';
import img10kw from './img/10kw.jpeg'
import img1kw from './img/1kw.jpeg'
import img30kw from './img/30kw.jpeg'
import img20kw from './img/20kw.jpeg'
import img15kw from './img/15kw.jpeg'
import img8kw from './img/8kw.jpeg'
import img5kw from './img/5kw.jpeg'
import img3kw from './img/3kw.jpeg'
import img15kwPng from './img/1.5kw.png'
import img25kw from './img/25kw.jpg'
import img12kw from './img/12kw.jpg'

import cctv4 from './img/4cctv.png'
import cctv3 from './img/3cctvs.png'
import cctv5 from './img/5cctvs.png'
import cctv6 from './img/6cctvs.png'
import cctv7 from './img/7cctvs.png'
import cctv8 from './img/8cctv.png'
import cctv10 from './img/10cctv.png'
import cctv13 from './img/13cctv.png'

import hvac from './img/hvac1.png'
import waterheat from './img/waterheat.png'
import waterheat2 from './img/waterheater2.png'
import waterheat3 from './img/waterheater3.png'
import waterheat5 from './img/waterheater5.png'


const Pricing = () => {
  const [activeTab, setActiveTab] = useState('solar');

  const customKitDetails = {
    '1 kW': {
      inverter: '1 kW inverter',
      battery: '2.200 AH battery',
      panels: '4 solar panels'
    },
    '3 kW': {
      inverter: '3 kW inverter',
      battery: '2.200 AH gel battery',
      panels: '6 solar panels'
    },
    '5 kW': {
      inverter: '5 kW inverter',
      battery: '5 kW battery',
      panels: '5 solar panels'
    },
    '8 kW': {
      inverter: '8 kW inverter',
      battery: '7 kW lithium battery',
      panels: '8 solar panels'
    },
    '10 kW': {
      inverter: '10 kW inverter',
      battery: '10 kW lithium battery',
      panels: '12 solar panels'
    },
    '15 kW': {
      inverter: '15 kW inverter',
      battery: '20 kW lithium battery',
      panels: '12 solar panels'
    }
  };

  const solarKits = [
    { size: '1 kW', price: 100000, popular: false },
    { size: '1.5 kW', price: 150000, popular: false },
    { size: '3 kW', price: 350000, popular: true },
    { size: '5 kW', price: 550000, popular: false },
    { size: '8 kW', price: 950000, popular: false },
    { size: '10 kW', price: 1100000, popular: false },
    { size: '12 kW', price: 1300000, popular: false },
    { size: '15 kW', price: 1800000, popular: false },
    { size: '20 kW', price: 2200000, popular: false },
    { size: '25 kW', price: 2600000, popular: false },
    { size: '30 kW', price: 3100000, popular: false }
  ];

  const solarPumps = [
    {
      model: 'GRUNDFOS Solar Water Pump',
      maxHead: '120 m',
      maxFlow: '2,750 L/hr',
      suitableFor: 'High flow, deep pumping',
      price: 280000,
      includes: 'Pump, controller, solar panels, cables'
    },
    {
      model: 'LORENTZ Solar Pump',
      maxHead: '120 m',
      maxFlow: '2,750 L/hr',
      suitableFor: 'High flow, deep pumping',
      price: 99000,
      includes: 'Pump, controller, solar panels, cables'
    },
    {
      model: 'PEDROLO Water Pump',
      maxHead: '65 m / 215 feet',
      maxFlow: '3,000 L/hr',
      suitableFor: 'Irrigation up to 3 acres',
      price: 129000,
      includes: 'Submersible pump, 50m electric cable, controller, Climate Smart battery fittings, 4 LED bulbs, USB charging ports'
    },
    {
      model: 'ROOMNY Solar Water Pump 1',
      maxHead: '30 m / 100 feet',
      maxFlow: '1,100 L/hr',
      suitableFor: 'Irrigation up to 1 acre',
      price: 75000,
      includes: 'Submersible pump, 50m electric cable, controller, 310W solar panel, 50m HDPE pipe and fittings'
    },
    {
      model: 'ROOMNY Solar Water Pump 2',
      maxHead: '30 m / 100 feet',
      maxFlow: '2,750 L/hr',
      suitableFor: 'Irrigation up to 2 acres',
      price: 99000,
      includes: 'Submersible pump, 50m electric cable, controller, 2 x 310W solar panels, 50m HDPE pipe and fittings'
    },
    {
      model: 'ROOMNY Solar Water Pump 3',
      maxHead: '65 m / 215 feet',
      maxFlow: '3,000 L/hr',
      suitableFor: 'Irrigation up to 3 acres',
      price: 129000,
      includes: 'Submersible pump, 50m electric cable, controller, Climate Smart battery fittings, 4 LED bulbs, USB charging ports'
    }
  ];

  const solarKitImages = {
    '1 kW': img1kw,
    '1.5 kW': img15kwPng,
    '3 kW': img3kw,
    '5 kW': img5kw,
    '8 kW': img8kw,
    '10 kW': img10kw,
    '12 kW': img12kw,
    '15 kW': img15kw,
    '20 kW': img20kw,
    '25 kW': img25kw,
    '30 kW': img30kw,
  };

  const cctvImages = {
    '4': cctv4,
    '3': cctv3,
    '5': cctv5,
    '6': cctv6,
    '7': cctv7,
    '8': cctv8,
    '9': cctv8,
    '10': cctv10,
    '11': cctv13,
    '12': cctv13,
    '13': cctv13,
  };

  const solarHeatImages = {
    '100 Liters': hvac,
    '150 Liters': waterheat,
    '200 Liters': waterheat2,
    '300 Liters': waterheat3,
    '500 Liters': waterheat5
  };

  const cctvPackages = [
    { cameras: 3, price: 28000 },
    { cameras: 4, price: 33000 },
    { cameras: 5, price: 40000 },
    { cameras: 6, price: 49000 },
    { cameras: 7, price: 54000 },
    { cameras: 8, price: 60000 },
    { cameras: 9, price: 70000 },
    { cameras: 10, price: 74000 },
    { cameras: 11, price: 80000 },
    { cameras: 12, price: 94000 },
    { cameras: 13, price: 100000 }
  ];

  const solarHeating = [
    { size: '100 Liters', price: 65000, capacity: '2-3 people', notes: 'Flat plate or evacuated tube' },
    { size: '150 Liters', price: 75000, capacity: '3-4 people', notes: 'Flat plate or evacuated tube' },
    { size: '200 Liters', price: 90000, capacity: '4-6 people', notes: 'Flat plate or evacuated tube' },
    { size: '300 Liters', price: 120000, capacity: '6-8 people', notes: 'Flat plate or evacuated tube' },
    { size: '500 Liters', price: 180000, capacity: '10+ people', notes: 'Commercial/large household' }
  ];

  const hvacServices = [
    { service: 'Split AC Installation (1 room)', price: 45000, note: 'incl. unit' },
    { service: 'Multi-room AC Installation', price: 120000, note: 'starting from' },
    { service: 'Annual AC Servicing', price: 7000, note: 'per unit' },
    { service: 'Heating System Installation', price: 60000, note: 'starting from' }
  ];

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 0
    }).format(price);
  };

  const tabs = [
    { id: 'solar', label: 'Solar Kits', icon: <Sun className="w-4 h-4" /> },
    { id: 'pumps', label: 'Solar Pumps', icon: <Droplets className="w-4 h-4" /> },
    { id: 'cctv', label: 'CCTV Systems', icon: <Shield className="w-4 h-4" /> },
    { id: 'heating', label: 'Solar Heating', icon: <Thermometer className="w-4 h-4" /> },
    { id: 'hvac', label: 'HVAC Services', icon: <Thermometer className="w-4 h-4" /> }
  ];

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash && tabs.some(tab => tab.id === hash)) {
        setActiveTab(hash);
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  useEffect(() => {
    const scrollToSection = () => {
      const element = document.getElementById(`${activeTab}-section`);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    };
    scrollToSection();
  }, [activeTab]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    window.history.pushState(null, null, `#${tabId}`);
  };

  const getPackageIncludes = (kitSize) => {
    const custom = customKitDetails[kitSize];
    
    if (custom) {
      return [
        custom.inverter,
        'AC & DC cables',
        custom.panels,
        custom.battery,
        'Mounting rails',
        'Circuit breakers (DC & AC)',
        'Lugs, cable ties, tapes, nails',
        'Professional installation'
      ];
    } else {
      return [
        'Inverter',
        'AC & DC cables',
        'Solar panels',
        'Batteries',
        'Mounting rails',
        'Circuit breakers (DC & AC)',
        'Lugs, cable ties, tapes, nails',
        'Professional installation'
      ];
    }
  };

  const tabColors = {
    active: '#712B35',
    inactive: '#f3f4f6',
    textActive: '#ffffff',
    textInactive: '#4b5563'
  };

  return (
    <div className="min-h-screen" style={{ background: '#fafafa' }}>
      {/* Page Header */}
      <section className="py-24 md:py-32 px-6 md:px-10" style={{ background: '#712B35' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">Our Pricing</h1>
          <p className="text-lg text-white/80 font-light">
            Transparent pricing for all your solar, security, and electrical needs
          </p>
        </div>
      </section>

      {/* Pricing Tabs */}
      <section className="py-16 md:py-24 px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-center gap-2 mb-12">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className="flex items-center gap-2 px-5 py-3 rounded-xl text-sm font-semibold transition-all duration-300"
                style={{
                  background: activeTab === tab.id ? tabColors.active : tabColors.inactive,
                  color: activeTab === tab.id ? tabColors.textActive : tabColors.textInactive
                }}
              >
                {tab.icon}
                <span>{tab.label}</span>
              </button>
            ))}
          </div>

          {/* Solar Kits */}
          {activeTab === 'solar' && (
            <div id="solar-section">
              <div className="text-center mb-12">
                <h2 className="text-2xl font-bold mb-2" style={{ color: '#2a2118' }}>Solar Kit Pricing</h2>
                <p className="text-sm font-light" style={{ color: '#5a524c' }}>Complete solar packages with installation included</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {solarKits.map((kit) => (
                  <div key={kit.size} className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300 relative">
                    {kit.popular && (
                      <div className="absolute top-4 left-4 z-10">
                        <span className="px-3 py-1.5 rounded-full text-xs font-semibold flex items-center gap-1 text-white" style={{ background: '#712B35' }}>
                          <Star className="w-3 h-3" />
                          Popular
                        </span>
                      </div>
                    )}

                    <div className="relative h-48 overflow-hidden" style={{ background: '#f9fafb' }}>
                      <img
                        src={solarKitImages[kit.size]}
                        alt={`${kit.size} Solar Kit`}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    </div>

                    <div className="p-6">
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-bold" style={{ color: '#2a2118' }}>{kit.size} Kit</h3>
                        <div className="text-xl font-bold" style={{ color: '#712B35' }}>{formatPrice(kit.price)}</div>
                      </div>

                      <div className="mb-6">
                        <p className="text-sm font-medium mb-3" style={{ color: '#2a2118' }}>Package includes:</p>
                        <ul className="text-sm space-y-1.5" style={{ color: '#5a524c' }}>
                          {getPackageIncludes(kit.size).map((item, index) => (
                            <li key={index} className="flex items-center gap-2">
                              <Check className="w-3.5 h-3.5 flex-shrink-0" style={{ color: '#489820' }} />
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>

                      <button 
                        className="w-full py-3 rounded-xl font-semibold text-white transition-all duration-300 hover:shadow-lg"
                        style={{ background: '#712B35' }}
                        onMouseEnter={(e) => e.target.style.background = '#5f2b40'}
                        onMouseLeave={(e) => e.target.style.background = '#712B35'}
                      >
                        Get Quote
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 p-6 rounded-xl border" style={{ background: '#fefce8', borderColor: '#fef08a' }}>
                <p className="text-sm" style={{ color: '#5a524c' }}>
                  <strong>Note:</strong> Price may vary depending on the brands and specific requirements.
                </p>
              </div>
            </div>
          )}

          {activeTab === 'pumps' && (
            <div id="pumps-section">
              <div className="text-center mb-12">
                <h2 className="text-2xl font-bold mb-2" style={{ color: '#2a2118' }}>Solar Water Pumps</h2>
                <p className="text-sm font-light" style={{ color: '#5a524c' }}>Efficient water pumping solutions for irrigation and domestic use</p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {solarPumps.map((pump, index) => (
                  <div key={index} className="bg-white rounded-2xl p-6 border border-gray-100 hover:shadow-xl transition-all duration-300">
                    <div className="flex justify-between items-start mb-4">
                      <h3 className="text-base font-bold" style={{ color: '#2a2118' }}>{pump.model}</h3>
                      <div className="text-lg font-bold whitespace-nowrap ml-4" style={{ color: '#712B35' }}>{formatPrice(pump.price)}</div>
                    </div>

                    <div className="grid grid-cols-2 gap-4 mb-4">
                      <div>
                        <p className="text-xs font-medium mb-0.5" style={{ color: '#9ca3af' }}>Max Head</p>
                        <p className="text-sm font-semibold" style={{ color: '#2a2118' }}>{pump.maxHead}</p>
                      </div>
                      <div>
                        <p className="text-xs font-medium mb-0.5" style={{ color: '#9ca3af' }}>Max Flow Rate</p>
                        <p className="text-sm font-semibold" style={{ color: '#2a2118' }}>{pump.maxFlow}</p>
                      </div>
                    </div>

                    <div className="mb-3">
                      <p className="text-xs font-medium mb-0.5" style={{ color: '#9ca3af' }}>Suitable For</p>
                      <p className="text-sm font-semibold" style={{ color: '#489820' }}>{pump.suitableFor}</p>
                    </div>

                    <div className="mb-5">
                      <p className="text-xs font-medium mb-1" style={{ color: '#9ca3af' }}>Includes</p>
                      <p className="text-sm leading-relaxed" style={{ color: '#5a524c' }}>{pump.includes}</p>
                    </div>

                    <button 
                      className="w-full py-3 rounded-xl font-semibold text-white transition-all duration-300 hover:shadow-lg"
                      style={{ background: '#712B35' }}
                      onMouseEnter={(e) => e.target.style.background = '#5f2b40'}
                      onMouseLeave={(e) => e.target.style.background = '#712B35'}
                    >
                      Get Quote
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'cctv' && (
            <div id="cctv-section">
              <div className="text-center mb-12">
                <h2 className="text-2xl font-bold mb-2" style={{ color: '#2a2118' }}>CCTV Systems</h2>
                <p className="text-sm font-light" style={{ color: '#5a524c' }}>Professional security camera installations</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {cctvPackages.map((pkg) => (
                  <div key={pkg.cameras} className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300">
                    <div className="relative h-48 overflow-hidden" style={{ background: '#f9fafb' }}>
                      <img
                        src={cctvImages[pkg.cameras]}
                        alt={`${pkg.cameras} CCTV Kit`}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    </div>
                    <div className="p-6">
                      <div className="text-center mb-4">
                        <div className="text-2xl font-bold mb-1" style={{ color: '#712B35' }}>{pkg.cameras}</div>
                        <p className="text-xs font-medium" style={{ color: '#5a524c' }}>Cameras</p>
                        <div className="text-xl font-bold mt-2" style={{ color: '#2a2118' }}>{formatPrice(pkg.price)}</div>
                      </div>

                      <div className="mb-5">
                        <p className="text-sm font-medium mb-2" style={{ color: '#2a2118' }}>Package includes:</p>
                        <ul className="text-xs space-y-1" style={{ color: '#5a524c' }}>
                          {['2MP HD cameras', '1080P DVR', 'Surveillance HDD', '25m cable per camera', 'Power supply', 'Adapter boxes', 'HDMI, power jack', 'Cable ties, tapes, nails', 'Professional installation'].map((item, index) => (
                            <li key={index} className="flex items-center gap-1.5">
                              <Check className="w-3 h-3 flex-shrink-0" style={{ color: '#489820' }} />
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>

                      <button 
                        className="w-full py-3 rounded-xl font-semibold text-white transition-all duration-300 hover:shadow-lg"
                        style={{ background: '#712B35' }}
                        onMouseEnter={(e) => e.target.style.background = '#5f2b40'}
                        onMouseLeave={(e) => e.target.style.background = '#712B35'}
                      >
                        Get Quote
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 p-6 rounded-xl border" style={{ background: '#fefce8', borderColor: '#fef08a' }}>
                <p className="text-sm" style={{ color: '#5a524c' }}>
                  <strong>Note:</strong> TV monitor not included in the package.
                </p>
              </div>
            </div>
          )}

          {activeTab === 'heating' && (
            <div id="heating-section">
              <div className="text-center mb-12">
                <h2 className="text-2xl font-bold mb-2" style={{ color: '#2a2118' }}>Solar Water Heating</h2>
                <p className="text-sm font-light" style={{ color: '#5a524c' }}>Eco-friendly water heating solutions</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {solarHeating.map((system) => (
                  <div key={system.size} className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300">
                    <div className="relative h-48 overflow-hidden" style={{ background: '#f9fafb' }}>
                      <img
                        src={solarHeatImages[system.size]}
                        alt={`${system.size} Solar Heating Kit`}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    </div>
                    <div className="p-6">
                      <div className="flex justify-between items-start mb-4">
                        <h3 className="text-base font-bold" style={{ color: '#2a2118' }}>{system.size}</h3>
                        <div className="text-lg font-bold" style={{ color: '#712B35' }}>{formatPrice(system.price)}</div>
                      </div>

                      <div className="mb-4">
                        <p className="text-xs font-medium mb-0.5" style={{ color: '#9ca3af' }}>Capacity</p>
                        <p className="text-sm font-semibold" style={{ color: '#489820' }}>{system.capacity}</p>
                      </div>

                      <div className="mb-5">
                        <p className="text-xs font-medium mb-0.5" style={{ color: '#9ca3af' }}>Type</p>
                        <p className="text-sm" style={{ color: '#5a524c' }}>{system.notes}</p>
                      </div>

                      <div className="mb-5">
                        <p className="text-sm font-medium mb-2" style={{ color: '#2a2118' }}>Package includes:</p>
                        <ul className="text-xs space-y-1" style={{ color: '#5a524c' }}>
                          {['Solar water heater tank', 'Solar collector', 'Mounting frame', 'Plumbing kit', 'Installation accessories', 'Full installation'].map((item, index) => (
                            <li key={index} className="flex items-center gap-1.5">
                              <Check className="w-3 h-3 flex-shrink-0" style={{ color: '#489820' }} />
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>

                      <button 
                        className="w-full py-3 rounded-xl font-semibold text-white transition-all duration-300 hover:shadow-lg"
                        style={{ background: '#712B35' }}
                        onMouseEnter={(e) => e.target.style.background = '#5f2b40'}
                        onMouseLeave={(e) => e.target.style.background = '#712B35'}
                      >
                        Get Quote
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 p-6 rounded-xl border" style={{ background: '#fefce8', borderColor: '#fef08a' }}>
                <p className="text-sm" style={{ color: '#5a524c' }}>
                  <strong>Note:</strong> Price may vary depending on the brand, roof type, and plumbing requirements.
                </p>
              </div>
            </div>
          )}

          {activeTab === 'hvac' && (
            <div id="hvac-section">
              <div className="text-center mb-12">
                <h2 className="text-2xl font-bold mb-2" style={{ color: '#2a2118' }}>HVAC Services</h2>
                <p className="text-sm font-light" style={{ color: '#5a524c' }}>Heating, ventilation, and air conditioning solutions</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {hvacServices.map((service, index) => (
                  <div key={index} className="bg-white rounded-2xl p-6 border border-gray-100 hover:shadow-xl transition-all duration-300">
                    <h3 className="text-base font-bold mb-3" style={{ color: '#2a2118' }}>{service.service}</h3>
                    <div className="flex items-center justify-between mb-4">
                      <div className="text-xl font-bold" style={{ color: '#712B35' }}>{formatPrice(service.price)}</div>
                      <span className="text-xs font-medium px-2.5 py-1 rounded-full" style={{ background: '#f3f4f6', color: '#6b7280' }}>{service.note}</span>
                    </div>

                    <button 
                      className="w-full py-3 rounded-xl font-semibold text-white transition-all duration-300 hover:shadow-lg"
                      style={{ background: '#712B35' }}
                      onMouseEnter={(e) => e.target.style.background = '#5f2b40'}
                      onMouseLeave={(e) => e.target.style.background = '#712B35'}
                    >
                      Get Quote
                    </button>
                  </div>
                ))}
              </div>

              <div className="mt-8 p-6 rounded-xl border" style={{ background: '#fefce8', borderColor: '#fef08a' }}>
                <p className="text-sm" style={{ color: '#5a524c' }}>
                  <strong>Note:</strong> Prices vary depending on brand, capacity, and site conditions. Contact us for a tailored quote.
                </p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 px-6 md:px-10 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase" style={{ color: '#712B35' }}>
              Why Us
            </span>
            <h2 className="text-2xl md:text-3xl font-bold mt-3 mb-2" style={{ color: '#2a2118' }}>
              Why Choose Our Services?
            </h2>
            <p className="text-sm font-light" style={{ color: '#5a524c' }}>Quality products, professional installation, and ongoing support</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-5" style={{ background: '#712B35' }}>
                <Check className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-base font-bold mb-1" style={{ color: '#2a2118' }}>Installation Included</h3>
              <p className="text-xs font-light" style={{ color: '#5a524c' }}>All our packages include professional installation by certified technicians</p>
            </div>
            <div className="text-center p-8">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-5" style={{ background: '#712B35' }}>
                <Star className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-base font-bold mb-1" style={{ color: '#2a2118' }}>Quality Guaranteed</h3>
              <p className="text-xs font-light" style={{ color: '#5a524c' }}>We use only premium brands and components for lasting performance</p>
            </div>
            <div className="text-center p-8">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-5" style={{ background: '#712B35' }}>
                <Phone className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-base font-bold mb-1" style={{ color: '#2a2118' }}>24/7 Support</h3>
              <p className="text-xs font-light" style={{ color: '#5a524c' }}>Round-the-clock customer support and maintenance services</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 px-6 md:px-10" style={{ background: '#712B35' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">Ready to Get Started?</h2>
          <p className="text-lg text-white/80 mb-6 font-light">Contact us today for a personalized quote and consultation</p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
            <a href="tel:0743076376" className="bg-white px-8 py-3.5 rounded-xl font-semibold transition-all duration-300 hover:shadow-xl hover:scale-105 flex items-center justify-center gap-2" style={{ color: '#712B35' }}>
              <Phone className="w-5 h-5" />
              Call: 0743076376
            </a>
            <a href="mailto:torchbearertechnologies@gmail.com" className="border-2 border-white text-white px-8 py-3.5 rounded-xl font-semibold transition-all duration-300 hover:bg-white hover:text-[#712B35] flex items-center justify-center gap-2">
              <Mail className="w-5 h-5" />
              Email Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
